import React, { useEffect, useState } from 'react';
import { TextSection } from 'polotno/side-panel';
import { useDispatch, useSelector } from 'react-redux';
import { updateName, updateNum } from '../../../redux/slices/PlanDetailSlice';
// import { addOrUpdateText } from '../../../utils/textUtils';

const CustomTextSection = {
	...TextSection,
	name: 'custom-text',
	Panel: ({ store }) => {
		const { textFieldsNum, textFieldsName } = useSelector(
			(state) => state.userPlan
		);

		const selectedType = useSelector((state) => state.sizeDimension.selectedType);

		const dispatch = useDispatch();
		const [showPlayerName, setShowPlayerName] = useState(false);
		const [showPlayerNumber, setShowPlayerNumber] = useState(false);
		const [customText, setCustomText] = useState('New Text');



		useEffect(() => {
			setShowPlayerName(textFieldsName);
		}, [textFieldsName]);


		useEffect(() => {
			setShowPlayerNumber(textFieldsNum);
		}, [textFieldsNum])		

			const addOrUpdateText = (page, id, isVisible, defaultText) => {
			const centerX = page.width / 2;
			const isNumber = id === page.id + "_playernumbertext";
			let fontSize, width, height, x, y;

			// For halfSleeves and A4/A3/A2/A1, use proportional sizing
			if (
				selectedType === "halfSleeves" ||
				selectedType === "a4" ||
				selectedType === "a3" ||
				selectedType === "a2" ||
				selectedType === "a1"
			) {
				fontSize = isNumber ? page.width * 0.18 : page.width * 0.08;
				width = isNumber ? page.width * 0.3 : page.width * 0.5;
				height = fontSize * 1.2;
				x = (page.width - width) / 2;
				y = isNumber ? page.height * 0.35 : page.height * 0.15;
			} else {
				// Fixed sizes for all other types
				fontSize = isNumber ? 673 : 138;
				width = isNumber ? 783 : 875;
				height = isNumber ? 809 : 167;
				x = centerX - width / 2;
				y = isNumber ? 639 : 200;
			}

			let existingText = page.children.find((child) => child.id === id);

			store.history.transaction(() => {
				if (existingText) {
					existingText.set({
						text: defaultText,
						visible: isVisible,
						fontSize,
						width,
						x,
						y,
					});
				} else if (isVisible) {
					page.addElement({
						id,
						type: "text",
						text: defaultText,
						fontFamily: "Arial",
						fontSize,
						lineHeight: 1.2,
						width,
						height,
						x,
						y,
					});
				}
			});
		};
		


			// const addOrUpdateText = (page, id, isVisible, defaultText) => {
			// const centerX = page.width / 2;
			// const centerY = page.height / 2;
			// let existingText = page.children.find((child) => child.id === id);
	  
			// store.history.transaction(() => {
			//   if (existingText) {
			// 	// Update existing text instead of creating a new one
			// 	existingText.set({
			// 	  text: defaultText,
			// 	  visible: isVisible,
			// 	  // x: centerX,
			// 	  // y: centerY,
			// 	});
			//   } else if (isVisible) {
			// 	// Add new text only if it's missing
			// 	const isNumber = id === page.id + "_playernumbertext" ? true : false;
			// 	page.addElement({
			// 	  id,
			// 	  type: "text",
			// 	  text: defaultText,
			// 	  fontFamily: "Arial",
			// 	  fontSize: isNumber ? 673 : 138,
			// 	  lineHeight: 1.2,
			// 	  width: isNumber ? 783 : 875,
			// 	  height: isNumber ? 809 : 167,
			// 	  x: centerX - (isNumber ? 783 : 875) / 2,
			// 	  y: isNumber ? 639 : 200,
			// 	});
			//   }
			// });
		  // };


		// Function to add or update text elements
		// const addOrUpdateText = (page, id, isVisible, defaultText) => {
		// 	const centerX = page.width / 2;
		// 	const centerY = page.height / 2;
		// 	let existingText = page.children.find((child) => child.id === id);

		// 	// Calculate proportional font size and width based on canvas size
		// 	const isNumber = id.includes('_playernumbertext');
		// 	let fontSize, width;
		// 	if (selectedType === "halfSleeves") {
		// 		fontSize = isNumber ? page.width * 0.22 : page.width * 0.12;
		// 		width = isNumber ? page.width * 0.3 : page.width * 0.5;
		// 	} else {
		// 		fontSize = isNumber ? page.width * 0.18 : page.width * 0.8;
		// 		width = isNumber ? page.width * 0.3 : page.width * 0.5;
		// 	}
		// 	const x = (page.width - width) / 2;
		// 	const y = isNumber ? page.height * 0.35 : page.height * 0.15;

		// 	store.history.transaction(() => {
		// 	  if (existingText) {
		// 		existingText.set({
		// 		  text: defaultText,
		// 		  visible: isVisible,
		// 		  fontSize,
		// 		  width,
		// 		  x,
		// 		  y,
		// 		});
		// 	  } else if (isVisible) {
		// 		page.addElement({
		// 		  id,
		// 		  type: "text",
		// 		  text: defaultText,
		// 		  fontFamily: "Arial",
		// 		  fontSize,
		// 		  lineHeight: 1.2,
		// 		  width,
		// 		  height: fontSize * 1.2,
		// 		  x,
		// 		  y,
		// 		});
		// 	  }
		// 	});
		// };

		// const addOrUpdateText = (page, id, isVisible, defaultText) => {
		// 	const centerX = page.width / 2;
		// 	const isNumber = id === page.id + "_playernumbertext";
		// 	let fontSize, width, height, x, y;

		// 	// Alag-alag ratios for each type
		// 	if (selectedType === "a4") {
		// 		fontSize = isNumber ? page.width * 0.16 : page.width * 0.07;
		// 		width = isNumber ? page.width * 0.28 : page.width * 0.48;
		// 		height = fontSize * 1.2;
		// 		x = (page.width - width) / 2;
		// 		y = isNumber ? page.height * 0.32 : page.height * 0.13;
		// 	} else if (selectedType === "a3") {
		// 		fontSize = isNumber ? page.width * 0.14 : page.width * 0.06;
		// 		width = isNumber ? page.width * 0.26 : page.width * 0.46;
		// 		height = fontSize * 1.2;
		// 		x = (page.width - width) / 2;
		// 		y = isNumber ? page.height * 0.30 : page.height * 0.12;
		// 	} else if (selectedType === "a2") {
		// 		fontSize = isNumber ? page.width * 0.12 : page.width * 0.055;
		// 		width = isNumber ? page.width * 0.24 : page.width * 0.44;
		// 		height = fontSize * 1.2;
		// 		x = (page.width - width) / 2;
		// 		y = isNumber ? page.height * 0.28 : page.height * 0.11;
		// 	} else if (selectedType === "a1") {
		// 		fontSize = isNumber ? page.width * 0.10 : page.width * 0.05;
		// 		width = isNumber ? page.width * 0.22 : page.width * 0.42;
		// 		height = fontSize * 1.2;
		// 		x = (page.width - width) / 2;
		// 		y = isNumber ? page.height * 0.26 : page.height * 0.10;
		// 	} else if (selectedType === "halfSleeves") {
		// 		fontSize = isNumber ? page.width * 0.18 : page.width * 0.08;
		// 		width = isNumber ? page.width * 0.3 : page.width * 0.5;
		// 		height = fontSize * 1.2;
		// 		x = (page.width - width) / 2;
		// 		y = isNumber ? page.height * 0.35 : page.height * 0.15;
		// 	} else {
		// 		// Default/fixed for other types
		// 		fontSize = isNumber ? 673 : 138;
		// 		width = isNumber ? 783 : 875;
		// 		height = isNumber ? 809 : 167;
		// 		x = centerX - width / 2;
		// 		y = isNumber ? 639 : 200;
		// 	}

		// 	let existingText = page.children.find((child) => child.id === id);

		// 	store.history.transaction(() => {
		// 		if (existingText) {
		// 			existingText.set({
		// 				text: defaultText,
		// 				visible: isVisible,
		// 				fontSize,
		// 				width,
		// 				x,
		// 				y,
		// 			});
		// 		} else if (isVisible) {
		// 			page.addElement({
		// 				id,
		// 				type: "text",
		// 				text: defaultText,
		// 				fontFamily: "Arial",
		// 				fontSize,
		// 				lineHeight: 1.2,
		// 				width,
		// 				height,
		// 				x,
		// 				y,
		// 			});
		// 		}
		// 	});
		// };
		


		// Function to add a new external text element (always new)ad
		
		// 		const addExternalText = () => {
		// 	const page = store.activePage;
		// 	if (!page) return;

		// 	const centerX = page.width / 2;
		// 	const centerY = page.height / 2;

		// 	store.history.transaction(() => {
		// 		page.addElement({
		// 			id: `external-text-${Date.now()}`, // Unique ID to ensure a new element is always created
		// 			type: 'text',
		// 			text: customText,
		// 			fontSize: 100,
		// 			fontFamily: 'Arial',
		// 			fill: 'black',
		// 			x: 573,
		// 			y: 1654,
		// 			visible: true,
		// 			width: 365,
		// 			height: 241,
		// 			lineHeight: 1.2,
		// 		});
		// 	});
		// };

		
		const addExternalText = () => {
			const page = store.activePage;
			if (!page) return;

			const centerX = page.width / 2;
			let fontSize, width, height, x, y;

			if (selectedType === "a4") {
				fontSize = page.width * 0.07;
				width = page.width * 0.48;
				height = fontSize * 1.2;
				x = (page.width - width) / 2;
				y = page.height * 0.13;
			} else if (selectedType === "a3") {
				fontSize = page.width * 0.06;
				width = page.width * 0.46;
				height = fontSize * 1.2;
				x = (page.width - width) / 2;
				y = page.height * 0.12;
			} else if (selectedType === "a2") {
				fontSize = page.width * 0.055;
				width = page.width * 0.44;
				height = fontSize * 1.2;
				x = (page.width - width) / 2;
				y = page.height * 0.11;
			} else if (selectedType === "a1") {
				fontSize = page.width * 0.05;
				width = page.width * 0.42;
				height = fontSize * 1.2;
				x = (page.width - width) / 2;
				y = page.height * 0.10;
			} else if (selectedType === "halfSleeves") {
				fontSize = page.width * 0.08;
				width = page.width * 0.5;
				height = fontSize * 1.2;
				x = (page.width - width) / 2;
				y = page.height * 0.15;
			} else if (selectedType === "fullSleeves") {
				fontSize = page.width * 0.08;
				width = page.width * 0.5;
				height = fontSize * 1.2;
				x = (page.width - width) / 2;
				y = page.height * 0.15;
			} else {
				// Default/fixed for other types (Jersey Design)
				fontSize = 138;
				width = 875;
				height = 167;
				x = centerX - width / 2;
				y = 200;
			}

			store.history.transaction(() => {
				page.addElement({
					id: `external-text-${Date.now()}`,
					type: 'text',
					text: customText,
					fontSize,
					fontFamily: 'Arial',
					fill: 'black',
					x,
					y,
					visible: true,
					width,
					height,
					lineHeight: 1.2,
				});
			});
		};

		// Handle toggling player name
		const togglePlayerName = () => {
			const newState = !showPlayerName;
			let obj = {
				name: newState,
				number: showPlayerNumber,
			};
			localStorage.setItem('fieldStatus', JSON.stringify(obj));
			setShowPlayerName(newState);
			dispatch(updateName(newState));
			const activePage = store.activePage;
			addOrUpdateText(
				activePage,
				activePage.id + '_playernametext',
				newState,
				'Name',
				false
			);
		};

		// Handle toggling player number
		const togglePlayerNumber = () => {
			const newState = !showPlayerNumber;
			let obj = {
				name: showPlayerName,
				number: newState,
			};
			localStorage.setItem('fieldStatus', JSON.stringify(obj));
			setShowPlayerNumber(newState);
			dispatch(updateNum(newState));

			const activePage = store.activePage;
			addOrUpdateText(
				activePage,
				activePage.id + '_playernumbertext',
				newState,
				'00',
				true
			);
		};

		return (
			<div style={{ padding: '10px' }}>
				<label className='customFontLabel'>
					<input
						type='checkbox'
						// checked={textFieldsName}
						checked={showPlayerName}
						onChange={togglePlayerName}
					/>
					<span className='customFontArea'>
						<span>Player Name Font</span>
						<span>Dynamic Text</span>
					</span>
				</label>

				<label className='customFontLabel'>
					<input
						type='checkbox'
						// checked={textFieldsNum}
						checked={showPlayerNumber}
						onChange={togglePlayerNumber}
					/>
					<span className='customFontArea'>
						<span>Player Number Font</span>
						<span>Dynamic Text</span>
					</span>
				</label>

				<div style={{ marginTop: '15px' }}>
					<button
						type='button'
						className='bp5-button bp5-minimal'
						style={{ width: '100%', fontSize: '18px', fontFamily: 'Roboto' }}
						onClick={addExternalText}
					>
						Add External Text
					</button>
				</div>
			</div>
		);
	},
};

export default CustomTextSection;
